import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-recent-activity-graph',
  templateUrl: './recent-activity-graph.component.html',
  styleUrls: ['./recent-activity-graph.component.css']
})
export class RecentActivityGraphComponent implements OnChanges {
  @Input() data = null;
  @Input() max = 0;
  yAxis: Array<number> = [];
  xAxisValue: Object = {'MON':'monday','TUE':'tuesday','WED':'wednesday','THU':'thurusday','FRI':'friday','SAT':'saturday','SUN':'sunday'};
  xAxis: Array<any> = ['MON','TUE','WED','THU','FRI','SAT','SUN'];
  @Input() height: number = 200;
  @Input() width: number = 480;

  graphData: Object = {
    'monday': {
      actual: {
        value: 0,
        height: 0,
        color: '#00AEEF',
        textBackground: 'rgb(0, 174, 239, 0.1)',
        done: false
      },
      committed: {
        value: 0,
        height: 0,
        color: '#FDA40A',
        textBackground: 'rgb(0, 174, 239, 0.1)'
      }
    },
    'tuesday': {
      actual: {
        value: 0,
        height: 0,
        color: '#00AEEF',
        textBackground: 'rgb(0, 174, 239, 0.1)',
        done: false
      },
      committed: {
        value: 0,
        height: 0,
        color: '#FDA40A',
        textBackground: 'rgb(0, 174, 239, 0.1)'
      }
    },
    'wednesday': {
      actual: {
        value: 0,
        height: 0,
        color: '#00AEEF',
        textBackground: 'rgb(0, 174, 239, 0.1)',
        done: false
      },
      committed: {
        value: 0,
        height: 0,
        color: '#FDA40A',
        textBackground: 'rgb(0, 174, 239, 0.1)'
      }
    },
    'thurusday': {
      actual: {
        value: 0,
        height: 0,
        color: '#00AEEF',
        textBackground: 'rgb(0, 174, 239, 0.1)',
        done: false
      },
      committed: {
        value: 0,
        height: 0,
        color: '#FDA40A',
        textBackground: 'rgb(0, 174, 239, 0.1)'
      }
    },
    'friday': {
      actual: {
        value: 0,
        height: 0,
        color: '#00AEEF',
        textBackground: 'rgb(0, 174, 239, 0.1)',
        done: false
      },
      committed: {
        value: 0,
        height: 0,
        color: '#FDA40A',
        textBackground: 'rgb(0, 174, 239, 0.1)'
      }
    },
    'saturday': {
      actual: {
        value: 0,
        height: 0,
        color: '#00AEEF',
        textBackground: 'rgb(0, 174, 239, 0.1)',
        done: false
      },
      committed: {
        value: 0,
        height: 0,
        color: '#FDA40A',
        textBackground: 'rgb(0, 174, 239, 0.1)'
      }
    },
    'sunday': {
      actual: {
        value: 0,
        height: 0,
        color: '#00AEEF',
        textBackground: 'rgb(0, 174, 239, 0.1)',
        done: false
      },
      committed: {
        value: 0,
        height: 0,
        color: '#FDA40A',
        textBackground: 'rgb(0, 174, 239, 0.1)'
      }
    }
  };
  ngOnChanges(changes: SimpleChanges): void {
    this.max = Math.ceil(this.max/3600);
    this.width -= 20;
    this.max = this.max%2==0?this.max:this.max+1;
    if(this.max < 2){
      this.max = 2;
    }
    for(let i=this.max;i>=0;i=i-2){
      this.yAxis.push(i);
    }
    for(let key in this.graphData){
      let keyCommitted = key+'Committed';
      this.graphData[key]['actual'].value = this.data[key]?this.data[key]:0;
      this.graphData[key]['actual'].height = (this.graphData[key]['actual'].value/3600/this.max*100).toFixed(2)+'%';
      this.graphData[key]['committed'].value = this.data[keyCommitted]?this.data[keyCommitted]:0;
      this.graphData[key]['committed'].height = (this.graphData[key]['committed'].value/3600/this.max*100).toFixed(2)+'%';
      if(this.graphData[key]['actual'].value>=this.graphData[key]['committed'].value){
        this.graphData[key]['actual'].done = true;
      }
    }
  }
}
